/**
 * 评论折叠/展开组件
 */
export class Folder {
  /**
   * 切换评论回复列表的展开/折叠状态
   * @param el 触发切换的元素（通常是带有 data-replies-toggle 的按钮）
   */
  static toggle(el: HTMLElement) {
    const commentId = el.dataset.repliesToggle;
    if (!commentId) return;

    const repliesContainer = document.getElementById(`replies-${commentId}`);
    // 使用 closest 查找父容器，使操作上下文更明确，提高魯棒性
    const commentItem = el.closest(".item");

    if (!repliesContainer || !commentItem) return;

    // 切换隐藏状态并同步 ARIA
    const isHidden = repliesContainer.classList.toggle("hidden");
    const isExpanded = !isHidden;
    repliesContainer.setAttribute("aria-hidden", String(isHidden));

    // 同步更新同一评论下的所有切换按钮的状态（通常有展开态和折叠态两个按钮）
    const toggleButtons = commentItem.querySelectorAll(
      `[data-replies-toggle="${commentId}"]`,
    );
    toggleButtons.forEach((btn) => {
      btn.setAttribute("aria-expanded", String(isExpanded));
    });

    // 切换辅助线和图标的显示状态
    const expandedLines = commentItem.querySelectorAll(
      ".replies-line-expanded",
    );
    const collapsedLines = commentItem.querySelectorAll(
      ".replies-line-collapsed",
    );

    expandedLines.forEach((line) => line.classList.toggle("hidden", isHidden));
    collapsedLines.forEach((line) =>
      line.classList.toggle("hidden", isExpanded),
    );
  }

  /**
   * Unpoly 编译器辅助方法，监听选择器匹配元素的点击事件
   * @param selector 切换按钮的选择器
   */
  static compiler(selector: string) {
    up.on("click", selector, (event: Event, element: HTMLElement) => {
      // 防止可能的默认行为
      event.preventDefault();
      Folder.toggle(element);
    });

    up.on("comments:reply", (event: any) => {
      const { parent, element } = event;
      if (!parent) return;

      const commentId = parent.id.replace("comment-", "");
      const repliesContainer = document.getElementById(`replies-${commentId}`);

      // 添加回复时，如果折叠着则自动展开
      if (repliesContainer?.classList.contains("hidden")) {
        const toggleBtn = parent.querySelector(
          `[data-replies-toggle="${commentId}"]`,
        );
        if (toggleBtn) {
          Folder.toggle(toggleBtn as HTMLElement);
        }
      }
    });

    up.on("comments:deleted", (event: any) => {
      const { commentId, position } = event;
      // 软删除保持结构不变，折叠状态也无需干预
    });
  }
}
